import { PermissionService } from "src/app/services/permission.service";
import { TOUCH_BUFFER_MS } from "@angular/cdk/a11y";
import { ThisReceiver } from "@angular/compiler";
import { ResumenListaDetallesComponent } from "./resumen-lista-detalles/resumen-lista-detalles.component";
import { THIS_EXPR } from "@angular/compiler/src/output/output_ast";
import { i18nMetaToJSDoc } from "@angular/compiler/src/render3/view/i18n/meta";
import { ChangeDetectorRef, Component, EventEmitter, OnInit, OnDestroy, AfterViewInit,ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import * as moment from "moment-timezone";
import { Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { PerfectScrollbarConfigInterface } from "ngx-perfect-scrollbar";
import { forkJoin, from, Observable, of, Subject } from "rxjs";
import { catchError, finalize, map, take, takeUntil } from "rxjs/operators";
import { ClienteInternacional } from "src/app/models/ClienteInternacional/ClienteInternacional";
import { Divisa } from "src/app/models/Divisa";
import { ComisionRecargo } from "src/app/models/Dte/ComisionRecargo";
import { DetalleDte } from "src/app/models/Dte/DetalleDte";
import { DteEmitido } from "src/app/models/Dte/DteEmitido";
import { ExportacionTransporteDte } from "src/app/models/Dte/exportacionDte";
import { FacturaExportacion } from "src/app/models/Dte/FacturaExportacion";
import { InvoiceType } from "src/app/models/Dte/invoiceType.enum";
import { OptionsReferenceDteEmitido } from "src/app/models/Dte/OptionsReferenceDteEmitido";
import { OptionsTransportDteEmitido } from "src/app/models/Dte/OptionsTransportDteEmitido";
import { ReferenciaDteEmitido } from "src/app/models/Dte/ReferenciaDteEmitido";
import { SolicitudDte } from "src/app/models/Dte/SolicitudDte";
import { TotalDteEmitido } from "src/app/models/Dte/TotalDteEmitido";
import { EstadoBorradorDte } from "src/app/models/Dte/estado-borrador-dte";
import { Impuesto } from "src/app/models/Impuesto";
import { GuiaDespacho } from "src/app/models/GuiaDespacho";
import { Producto } from "src/app/models/Producto/Producto";
import { Proveedor } from "src/app/models/Proveedor/Proveedor";
import { Receptor } from "src/app/models/Receptor/Receptor";
import { TipoDte } from "src/app/models/tipoDte";
import { DashboardService } from "src/app/services/dashboard.service";
import { DteEmitidosService } from "src/app/services/dte-emitidos.service";
import { DteExportacionService } from "src/app/services/dte-exportacion.service";
import { FacturacionIndividualService } from "src/app/services/facturacion-individual.service";
import { BorradorDteService } from "src/app/services/borrador-dte.service";
import { FoliosService } from "src/app/services/folios.service";
import { LocalStorageService } from "src/app/services/local-storage.service";
import { ProductoService } from "src/app/services/producto.service";
import { TokenStorageService } from "src/app/services/token-storage.service";
import { UtilitiesService } from "src/app/services/utilities.service";
import { InvoicingButton } from "src/app/shared/models/InvoicingButton.enum";
import { Response } from "src/app/shared/models/Response";
import { SessionUser } from "src/app/shared/models/sessionUser";
import { SubheaderService } from "src/app/_metronic/partials/layout/subheader/_services/subheader.service";
import { PasoTour, TourService } from "src/app/services/tour-tutorial.service";
import { ConfiguracionesTour } from "src/app/shared/models/tour-tutorial-configurations";
import { UsuarioService } from "src/app/services/usuario.service";
import { environment } from "src/environments/environment";
import Swal from "sweetalert2";
import { FacturaCompra } from "../../../models/Dte/FacturaCompra";
import { IDte } from "../../../models/Dte/IDte";
import { TipoDespachoEnum } from "src/app/models/Dte/TipoDespacho.enum";
import { TipoTraslado } from "src/app/models/TipoTraslado";
import { NotaDebito } from "src/app/models/NotaDebito";
import { NotaCredito } from "src/app/models/NotaCredito";
import { OpcionesReferenciasDteComponent } from "./opciones-referencias-dte/opciones-referencias-dte.component";
import { EmisorService } from "src/app/services/emisor.service";
import { SessionUserService } from "src/app/modules/auth/session-user/session-user.service";
import { esIndicadorServicioLocalExportacion, IndicadorServicioExportacion } from "src/app/models/Dte/IndicadorServicio.enum";
import { PlanUsuarioService } from "src/app/services/planUsuario.service";
import { buildOptionsReferenceForCopiedDte, buildTransportOptionsForCopiedDte, mapDetallesForCopiedDte, mapReferenciasDetalleToEmitidas } from "./copiar-dte.mapper";
import { PlantillaDte } from "src/app/models/Dte/PlantillaDte";
import { PanelComplementarioComponent, PanelComplementarioTab } from "./panel-complementario/panel-complementario.component";
import { DteEmissionService } from "src/app/services/dte-emission.service";
import { prepararDetalleCorreccionTexto, prepararPayloadExportacion } from "./dte-payload/dte-payload.factory";
import { obtenerConfiguracionDte, obtenerNombreDtePorCodigo } from "./dte-type-configuration/dte-type-configuration";
import { agruparReferenciasDeGuias, mapearGuiaAReferencia, mapearGuiasADetalles, mapearGuiasAReferencias, mapearReferenciasDocumentosDeGuias } from "./guide-invoice/guide-invoice.mapper";
import { validarDte } from "src/app/services/dte-validation.service";
import { esTipoCambioValido } from "./dte-currency/dte-currency";
import { calcularTotalDetalles, tieneDetallesConMontosInvalidos } from "./dte-calculation/dte-calculation";
import { aplicarOpcionesReferencias, aplicarOpcionesTransporte, aplicarRutReceptor, aplicarTotales } from "./dte-form-state/dte-form-state.mapper";
import { FolioSummary, resumirFolios } from "./folio-summary/folio-summary.mapper";
import { FacturadorNotificationService } from "src/app/services/facturador-notification.service";
import { BuscadorClienteComponent } from "./buscador-cliente/buscador-cliente.component";
@Component({
	selector: "app-facturador-individual",
	templateUrl: "./facturador-individual.component.html",
	styleUrls: ["./facturador-individual.component.scss"],
})
export class FacturadorIndividualComponent implements OnInit, OnDestroy, AfterViewInit {
	@ViewChild(BuscadorClienteComponent) private buscadorCliente?: BuscadorClienteComponent;
	@ViewChild("panelComplementario") private panelComplementario?: PanelComplementarioComponent;
	@ViewChild("resumenRef") private resumen?: ResumenListaDetallesComponent;
	codigoTipoDte: number;
	motivoNota: string = "";
	notaForm: FormGroup;
	tipoNota: number = -1;
	itemsCorreccion: string = "";
	disableDetailFields: boolean = false;
	public observacionesDte: string = "";
	public tipoPago: string = "";
	public loading: boolean = false;
	public indicadorServicioExportacion: number = 0;
	//private newDte: DteEmitido = new DteEmitido();
	private newDte: IDte = new SolicitudDte();
	public dteExistente: DteEmitido;
	public listaDetallesFacturador: DetalleDte[] = [];
	private listaDetallesObservable$: Observable<DetalleDte[]>;
	private listaComisionesObservable$: Observable<ComisionRecargo[]>;
	private clienteIdObservable$: Observable<string>;
	private optionsRefObservable$: Observable<OptionsReferenceDteEmitido>;
	private optionsTransportObservable$: Observable<OptionsTransportDteEmitido>;
	private totalesDteObservable$: Observable<TotalDteEmitido>;
	public dteInvoice: DteEmitido = new DteEmitido();
	public dteSubmitted: boolean = false;
	public listDivisas: Divisa[] = [];
	public showInGuide: boolean = false;
	public showTransporte: boolean = false;
	public dontShowInSettlement: boolean = false;
	public showInSettlement = false;
	private listElementsWithTax: boolean = false;
	public showInExportInvoice: boolean = false;
	public receptor: any = null;
	public porcentajeIva: number = environment.taxPercentage;
	public InvoiceType = InvoiceType;
	public invoiceType: InvoiceType = InvoiceType.Factura;
	private exportacionObservable$: Observable<ExportacionTransporteDte>;
	public loadingDivisas$: Observable<boolean>;
	public errorDivisas = false;
	public invalidSize$: Observable<boolean>;
	public invalidSize: boolean = false;
	public buttonAction$: Observable<InvoicingButton>;
	private destroySubscriptions$: Subject<void> = new Subject<void>();
	private emisionEnCurso: boolean = false;
	public listaGuiasFacturables: DteEmitido[] = [];
	public configScroll: PerfectScrollbarConfigInterface = {};
	@ViewChild("GuidesListToInvoices") listaGuiasModalRef: any;
	@ViewChild("opcionesRef") opcionesRef: OpcionesReferenciasDteComponent;
	private guiasModal: any;
	public selectedGuides: DteEmitido[] = []; //dtes seleccionados por checkbox
	public incluirDocumentosReferenciadosGuias = false;
	private currentGlobaleCheckGuidRefs: boolean = false;
	public selectedAllItemsInPage: Record<number, boolean> = {}; // bool para la seleccion total de elementos en tabla
	private responseResult: string;
	private currentSucursalId: string = this.tokenService.getSubsidiary();
	private listFolioResumen: FolioSummary[] = [];
	private tipoDteSource = JSON.parse(this.localStorage.getDteTypes()) as TipoDte[];
	public currentGrupoFolio: FolioSummary | undefined;
	public loadingFoliosSummary$: Observable<boolean>;
	public valorUF135: number = 0;
	public requiereIdentificacionReceptor: boolean = false;
	private currentOptionsRefState: OptionsReferenceDteEmitido = new OptionsReferenceDteEmitido();
	private currentTransportOptionsState: OptionsTransportDteEmitido = new OptionsTransportDteEmitido();
	private currentTotalsState: TotalDteEmitido = new TotalDteEmitido();
	public currentExportacionState: ExportacionTransporteDte = new ExportacionTransporteDte();
	private temporizadorPersistenciaBorrador: ReturnType<typeof setTimeout>;
	private restaurandoBorrador: boolean = false;
	private deshabilitarSeguimientoBorrador: boolean = false;
	private verificacionBorradorCompletada: boolean = false;
	private documentoEmitidoExitosamente: boolean = false;
	private currentUserId: string;
	private currentEmisorId: string;
	public plantillas: PlantillaDte[] = [];
	public plantillaSeleccionada: PlantillaDte = null;
	private currentCodigosTipoDtePlantillas: number[] = null;
	private guardarComoFrecuenteSolicitado: boolean = false;
	private emisionFrecuenteModal: any;
	@ViewChild("EmisionFrecuenteModal") emisionFrecuenteModalRef: any;
	private monedaModal: any;
	@ViewChild("MonedaModal") monedaModalRef: any;
	private readonly codigosDteConGiroRecepObligatorio = new Set([33, 34, 43, 46, 52]);
	locale = {
		daysOfWeek: moment.weekdaysMin(),
		monthNames: moment.monthsShort(),
		firstDay: moment.localeData().firstDayOfWeek(),
		applyLabel: "ok",
		clearLabel: "Limpiar",
		format: "DD/MM/YYYY",
	};
	constructor(
		public permissions: PermissionService,
		private facturador: FacturacionIndividualService,
		private tokenService: TokenStorageService,
		private ref: ChangeDetectorRef,
		private utilities: UtilitiesService,
		private dashboard: DashboardService,
		private router: Router,
		private localStorage: LocalStorageService,
		private productService: ProductoService,
		private subheaderService: SubheaderService,
		private modalService: NgbModal,
		private dteService: DteEmitidosService,
		private dteExportaService: DteExportacionService,
		private foliosService: FoliosService,
		private emisorService: EmisorService,
		private fb: FormBuilder,
		private sessionUserService: SessionUserService,
		private borradorService: BorradorDteService,
		private planUsuarioService: PlanUsuarioService,
		private tourService: TourService,
		private usuarioService: UsuarioService,
		private dteEmissionService: DteEmissionService,
		private notifications: FacturadorNotificationService
	) {
		this.listaDetallesObservable$ = this.facturador.detalleDteListObservable;
		this.listaComisionesObservable$ = this.facturador.detalleComisionDteListObservable;
		this.clienteIdObservable$ = this.facturador.clienteIdObservable;
		this.optionsRefObservable$ = this.facturador.opcionesReferenciaObservable;
		this.optionsTransportObservable$ = this.facturador.opcionesTransporteObservable;
		this.totalesDteObservable$ = this.facturador.resumenTotalesObservable;
		this.exportacionObservable$ = this.facturador.exportacionTransporteObservable;
		this.loadingDivisas$ = this.dashboard.isLoadingDailyDivisas;
		this.invalidSize$ = this.facturador.invalidSizeObservable;
		this.buttonAction$ = this.facturador.buttonActionsObservable;
		this.loadingFoliosSummary$ = this.foliosService.isLoadingFolios;
	}

	ngOnInit(): void {
		this.dontShowInSettlement = false;
		this.showInSettlement = false;
		this.selectedGuides = [];
		this.documentoEmitidoExitosamente = false;
		const currentUser = this.tokenService.getUser() as SessionUser;
		this.currentUserId = currentUser?.id;
		this.currentEmisorId = this.tokenService.getCompany();
		this.sessionUserService.verificarSesionUsuario();

		const planActual = this.planUsuarioService.getActualPlan();
		if (planActual?.idPlanUsuario) {
			this.planUsuarioService.getCurrentDocuments(planActual.idPlanUsuario).subscribe({
				next: (result) => {
					if (result?.maxdtes === 0) {
						Swal.fire({
							icon: "warning",
							title: "Acceso no permitido",
							text: "Su plan actual (Sólo DTE Recibidos) no permite la emisión de documentos tributarios electrónicos. Será redirigido al mantenedor de documentos recibidos.",
							confirmButtonText: "Aceptar",
						}).then(() => {
							this.router.navigateByUrl("compras/documentos-recibidos");
						});
					}
				}
			});
		}

		this.obtenerParametrosUF();

		this.listaDetallesObservable$.pipe(takeUntil(this.destroySubscriptions$)).subscribe((list) => {
			this.newDte.detalleDte = list.filter((detail) => detail.cantidad > 0);
			this.alActualizarContenidoBorrador();
		});
		this.listaComisionesObservable$.pipe(takeUntil(this.destroySubscriptions$)).subscribe((list) => {
			this.newDte.comisionesCargosDte = list.filter((detail) => detail.cantidad > 0);
			this.alActualizarContenidoBorrador();
		});
		this.clienteIdObservable$.pipe(takeUntil(this.destroySubscriptions$)).subscribe((rut) => {
			aplicarRutReceptor(this.newDte, rut);
			this.alActualizarContenidoBorrador();
		});
		this.optionsTransportObservable$.pipe(takeUntil(this.destroySubscriptions$)).subscribe((optionTransport) => {
			this.currentTransportOptionsState = Object.assign(new OptionsTransportDteEmitido(), optionTransport ? optionTransport : new OptionsTransportDteEmitido());
			aplicarOpcionesTransporte(this.newDte, optionTransport, this.invoiceType);
			this.alActualizarContenidoBorrador();
		});
		this.optionsRefObservable$.pipe(takeUntil(this.destroySubscriptions$)).subscribe((optionsRef) => {
			this.currentOptionsRefState = Object.assign(new OptionsReferenceDteEmitido(), optionsRef ? optionsRef : new OptionsReferenceDteEmitido());
			this.listElementsWithTax = optionsRef.sonDetallesConIVA;
			aplicarOpcionesReferencias(this.newDte, optionsRef);
			//pass global reference to list of guide references
			if (optionsRef.globalReferenceForGuideRefs != this.currentGlobaleCheckGuidRefs && optionsRef.globalReferenceForGuideRefs != undefined) {
				this.currentGlobaleCheckGuidRefs = optionsRef.globalReferenceForGuideRefs;
				if (optionsRef.globalReferenceForGuideRefs && this.selectedGuides && this.selectedGuides.length > 0) {
					this.guideToGroupedReferenceItem(this.selectedGuides);
				} else if (!optionsRef.globalReferenceForGuideRefs && this.selectedGuides && this.selectedGuides.length > 0) {
					this.processGuideToReferences(this.selectedGuides);
				}
			}
			this.alActualizarContenidoBorrador();
		});
		this.totalesDteObservable$.pipe(takeUntil(this.destroySubscriptions$)).subscribe((totales) => {
			if (totales) {
				this.currentTotalsState = Object.assign(new TotalDteEmitido(), totales);
				aplicarTotales(this.newDte, totales);
				this.sendTipoFolio(totales.codigoTipoDte);
				this.validarRequerimientoIdentificacionReceptor();
				if (this.newDte.codigoTipoDte == 33 || this.newDte.codigoTipoDte == 34) {
					this.showInGuide = false;
				}
				this.alActualizarContenidoBorrador();
			}
		});
		this.cargarDivisas();

		this.exportacionObservable$.pipe(takeUntil(this.destroySubscriptions$)).subscribe((exportacion) => {
			this.currentExportacionState = Object.assign(new ExportacionTransporteDte(), exportacion ? exportacion : new ExportacionTransporteDte());
			if (this.newDte instanceof FacturaExportacion) {
				this.newDte.transporte = exportacion;
				this.newDte.setExportData(this.newDte.transporte);
				this.alActualizarContenidoBorrador();
			}
		});

		this.invalidSize$.pipe(takeUntil(this.destroySubscriptions$)).subscribe((isInvalid) => {
			this.invalidSize = isInvalid;
		});

		this.buttonAction$.pipe(takeUntil(this.destroySubscriptions$)).subscribe((action) => {
			if (action == InvoicingButton.Emitir) {
				this.consolidateDte(true);
			}
			if (action == InvoicingButton.EmitirYGuardarFrecuente) {
				this.consolidateDte(true, true);
			}
			if (action == InvoicingButton.Previsualizar) {
				this.consolidateDte(false);
			}
			if (action == InvoicingButton.Cancelar) {
				this.returnToMaintainer();
			}
			if (action == InvoicingButton.FacturarGuias) {
				this.consultaGuiasFacturablesCliente();
			}
		});

		this.getDocTypeParamFromStateRoute();

		if (this.invoiceType == InvoiceType.NotaCredito) {
			this.codigoTipoDte = 61;
			Swal.fire({
				title: "Advertencia",
				text: "Esta nota de crédito estará referenciando a documentos que no tenemos registrados en nuestros sistemas, por lo que no podemos garantizar que esta sea aceptada. Es su responsabilidad asegurarse de que el documento referenciado esté en regla en el SII y que los datos coincidan con el origen, de lo contrario, esta podría ser rechazada.",
				icon: "warning",
				confirmButtonText: "Entendido",
			});
			this.notaForm = this.fb.group({
				motivo: [null, Validators.required],
				itemsCorreccion: [""],
			});
		} else if (this.invoiceType == InvoiceType.NotaDebito) {
			this.codigoTipoDte = 56;
			Swal.fire({
				title: "Advertencia",
				text: "Esta nota de débito estará referenciando a documentos que no tenemos registrados en nuestros sistemas, por lo que no podemos garantizar que esta sea aceptada. Es su responsabilidad asegurarse de que el documento referenciado esté en regla en el SII y que los datos coincidan con el origen, de lo contrario, esta podría ser rechazada.",
				icon: "warning",
				confirmButtonText: "Entendido",
			});
			this.notaForm = this.fb.group({
				motivo: [null, Validators.required],
				itemsCorreccion: [""],
			});
		}
	}

	onIndicadorServicioExport(valor: number | null) {
		this.indicadorServicioExportacion = valor ?? 0;
		this.alActualizarContenidoBorrador();
	}

	onObservacionesChange(valor: string) {
		this.observacionesDte = valor;
		this.alActualizarContenidoBorrador();
	}

	onTipoPagoChange(valor: string) {
		this.tipoPago = valor ?? "";
		this.newDte.tipoPago = this.tipoPago;
		this.alActualizarContenidoBorrador();
	}

	getFormatSizes(emisorId: string, tipoDteId: string) {
		this.facturador.getFormatSizeItems(emisorId, tipoDteId).subscribe(
			(result) => {
				this.facturador.updateFormatoDte(result.data);
			},
			(error) => {
				const tipoDocumento = this.getTipoDocumentoPlantilla(tipoDteId);
				Swal.fire({
					icon: "error",
					title: "Plantilla de impresión no configurada",
					html: `
						<div>
							No es posible emitir ${tipoDocumento} porque no tienes asignada una plantilla de impresión para este tipo de documento.<br>
							Puedes configurarla siguiendo estos pasos:<br><br>
							1. Ve a Configuración.<br>
							2. Selecciona "Mis Plantillas de Impresión".<br>
							3. Asigna una plantilla de impresión para ${tipoDocumento}.<br>
							4. Intenta emitir nuevamente este documento.
						</div>
						`,
					customClass: {
						htmlContainer: 'swal-text-left'
					},
					showConfirmButton: true,
				}).then(() => {
					this.returnToMaintainer();
				});
				//Swal.fire({icon:'error',title:'Error en plantilla',text:'No se obtuvo el registro de plantilla para el tipo de documento a emitir'})
			}
		);
	}

	private getTipoDocumentoPlantilla(tipoDteId: string): string {
		const tipoDte = this.tipoDteSource?.find((type) => type.tipoDteId == tipoDteId);
		const nombreTipoDte = tipoDte?.nombre || tipoDte?.descripcion;

		return this.normalizarNombreTipoDte(nombreTipoDte);
	}

	private normalizarNombreTipoDte(nombreTipoDte: string): string {
		if (!nombreTipoDte) {
			return "este tipo de documento";
		}

		return nombreTipoDte.replace(/\s+Electr[oó]nica$/i, "").trim();
	}

	onMotivoChange(motivo: string) {
		this.motivoNota = motivo;
		this.notaForm.get("motivo").setValue(motivo);
		this.alActualizarContenidoBorrador();
	}
	onTipoNotaSeleccionado(tipoNota: number) {
		this.tipoNota = tipoNota;
		if (this.tipoNota === -1) {
			this.mostrarError("Error en el motivo", "El motivo seleccionado no es válido. Seleccione un motivo de la lista disponible.");
		}

		if (this.invoiceType === InvoiceType.NotaCredito && this.tipoNota === 2) {
			this.disableDetailFields = true;
			this.clearDetailFields();
			this.notaForm.get("itemsCorreccion").setValidators([Validators.required]);
		} else {
			this.disableDetailFields = false;
			this.notaForm.get("itemsCorreccion").clearValidators();
			this.notaForm.get("itemsCorreccion").setValue("");
		}
		this.notaForm.get("itemsCorreccion").updateValueAndValidity();
		this.alActualizarContenidoBorrador();
	}
	clearDetailFields() {
		this.facturador.clearAllDetails();
		this.documentoEmitidoExitosamente = false; // Resetear bandera al limpiar campos
	}
	buildNotaCredito(tipoNota: number): NotaCredito {
		const notaCredito = new NotaCredito();
		notaCredito.motivoString = this.notaForm.get("motivo")?.value;
		notaCredito.tipoNota = tipoNota;
		if (tipoNota === 1 || tipoNota === 2) {
			notaCredito.neto = Math.round(this.newDte.neto);
			notaCredito.iva = Math.round(this.newDte.iva);
			notaCredito.total = Math.round(this.newDte.total);
		}
		if (this.newDte.listaReferenciasDteEmitido) {
			notaCredito.razonReferencias = this.newDte.listaReferenciasDteEmitido.map((ref) => `${ref.razonReferencia}`).join("; ");
			notaCredito.folio = parseInt(this.newDte.listaReferenciasDteEmitido.map((ref) => ref.folioReferencia).join("; "), 10);
			notaCredito.fechaNota = this.newDte.listaReferenciasDteEmitido.map((ref) => ref.fechaDteReferenciado).join("; ");
		} else {
			notaCredito.razonReferencias = "";
		}
		if (tipoNota === 1 || tipoNota === 2) {
			if (this.newDte.detalleDte) {
				notaCredito.itemsNota = this.newDte.detalleDte.filter((detalle) => detalle.cantidad > 0).map((detalle) => Object.assign(new DetalleDte(), detalle));
			}
		}
		if (tipoNota === 2) {
			const textoCorreccion = this.notaForm.get("itemsCorreccion")?.value?.trim();
			if (notaCredito.itemsNota == null) {
				notaCredito.itemsNota = [];
			}

			if (textoCorreccion) {
				notaCredito.itemsNota.push({
					descripcion: textoCorreccion,
				});
			}
		}
		return notaCredito;
	}

	ngAfterContentInit() {
		setTimeout(() => {
			this.subheaderService.setTitle("");
			this.subheaderService.setBreadcrumbs([]);
		}, 0.1);
	}

	addClientToInvoiceRequest(client: any) {
		this.dteInvoice.rutReceptor = client.rutString;
		this.newDte.razonSocial = client.razonSocial;

		this.receptor = client;
		this.facturador.selectedClient = client;
		if (this.newDte instanceof FacturaExportacion) {
			const clienteIdExistente = (this.newDte as FacturaExportacion).clienteInternacionalId;
			
			this.newDte.clienteInternacionalId = client.clienteInternacionalId || clienteIdExistente;
			this.newDte.razonSocial = client.razonSocial;
			if (client.nombrePais) {
				(this.receptor as any).nombrePais = client.nombrePais;
			}
			if (client.paisId) {
				(this.receptor as any).paisId = client.paisId;
			}
			if (client.codigoPais) {
				(this.receptor as any).codigoPais = client.codigoPais;
			}
			const clienteIdParaReceptor = client.clienteInternacionalId || clienteIdExistente || (this.receptor as any)?.clienteInternacionalId;
			if (clienteIdParaReceptor) {
				(this.receptor as any).clienteInternacionalId = clienteIdParaReceptor;
			}
		}
		this.alActualizarContenidoBorrador();
	}
	addProveedorToInvoiceRequest(proveedor: Proveedor) {
		this.receptor = proveedor;
		this.dteInvoice.rutReceptor = proveedor.rutProveedor;
		this.newDte.razonSocial = proveedor.razonSocial;
		this.receptor.emisorId = this.currentEmisorId;
		this.facturador.selectedProveedor = proveedor;
		if (this.newDte instanceof FacturaCompra) {
			this.newDte.rutProveedor = proveedor.rutProveedor;
		}
		this.alActualizarContenidoBorrador();
	}
	private obtenerParametrosUF(): void {
		this.facturador.getParametros().subscribe(
			(response) => {
				if (response.data) {
					const parametroUFBoleta = response.data;
					if (parametroUFBoleta && parametroUFBoleta.valor) {
						this.valorUF135 = parseFloat(parametroUFBoleta.valor);
					}

				}
			}
		);
	}

	private validarRequerimientoIdentificacionReceptor(): void {
		const esBoleta = this.invoiceType === InvoiceType.Boleta;
		const totalSuperado = this.newDte.total > this.valorUF135;

		this.requiereIdentificacionReceptor = esBoleta && totalSuperado && this.valorUF135 > 0;

		if (this.requiereIdentificacionReceptor) {
			console.warn(`⚠️ RESOLUCIÓN SII N°44: Boleta de $${this.newDte.total.toLocaleString()} supera el total de $${this.valorUF135.toLocaleString()} (135 UF). Se requiere identificación del receptor.`);
		}
	}

	private requiereGiroReceptor(codigoTipoDte?: number): boolean {
		return codigoTipoDte != null && this.codigosDteConGiroRecepObligatorio.has(codigoTipoDte);
	}

	private tieneGiroReceptorInformado(): boolean {
		return !!this.receptor?.giro && this.receptor.giro.toString().trim().length > 0;
	}

	async consolidateDte(sender: boolean, guardarComoFrecuente: boolean = false) {
		if (!(this.permissions.canIssueInvoice(this.invoiceType))) { return; }
		if (this.emisionEnCurso) return;
		if (!this.resumen?.validarFechaEmisionActual()) return;
		if (this.currentOptionsRefState?.tipoMoneda !== "CLP" && this.currentOptionsRefState?.tipoMoneda && !esTipoCambioValido(this.currentOptionsRefState.valorTipoMoneda)) {
			Swal.fire("Falta el valor de la moneda", "Abra Moneda y vuelva a cargar la cotización o ingrese un valor mayor que cero antes de continuar.", "warning");
			return;
		}

		this.guardarComoFrecuenteSolicitado = guardarComoFrecuente;
		this.newDte.observaciones = this.observacionesDte;
		this.newDte.tipoPago = this.tipoPago.trim() || undefined;

		if (this.showInSettlement) {
			this.facturador.clearUnfilledComisionItems();
		} else {
			this.facturador.clearUnfilledItems();
		}

		const usuarioId = this.currentUserId || (this.tokenService.getUser() as SessionUser)?.id;
		const sucursalId = this.currentSucursalId || this.tokenService.getSubsidiary();
		const emisorId = this.currentEmisorId || this.tokenService.getCompany();
		this.newDte.receptorEnt = this.receptor ? { ...this.receptor, receptorId: this.receptor.receptorId ?? undefined } : this.receptor;
		this.newDte.receptorId = this.receptor?.receptorId ?? null;
		this.newDte.clienteId = this.receptor?.clienteId ?? null;
		this.newDte.emisorId = emisorId;
		this.normalizarDetallesAntesDeEmitir();

		this.opcionesRef?.sincronizarReferencias();
		const referenciasActivas = !!this.opcionesRef?.optionsReferenceFormGroup?.get("haveDteReference")?.value;
		const guiaDespacho = this.newDte.guiaDespacho;
		const requiereDatosTransporte =
			this.invoiceType === InvoiceType.GuiaDespacho ||
			(this.invoiceType === InvoiceType.Factura && this.currentTransportOptionsState.facturaAcompanaTraslado);
		const transporteIncompleto =
			requiereDatosTransporte &&
			(!guiaDespacho ||
				!guiaDespacho.tipoDespacho ||
				(this.invoiceType === InvoiceType.GuiaDespacho && !guiaDespacho.tipoTraslado) ||
				(!!guiaDespacho.rutChofer && (!guiaDespacho.dvChofer || `${guiaDespacho.rutChofer}-${guiaDespacho.dvChofer}`.length > 10)) ||
				(!!guiaDespacho.nombreChofer && !guiaDespacho.nombreChofer.toString().trim()) ||
				(guiaDespacho.nombreChofer?.toString().length ?? 0) > 30 ||
				(!!guiaDespacho.rutTransporte && (!guiaDespacho.dvTransporte || `${guiaDespacho.rutTransporte}-${guiaDespacho.dvTransporte}`.length > 10)) ||
				(!!guiaDespacho.patente && guiaDespacho.patente.toString().length > 8) ||
				(!!guiaDespacho.patenteCarro && guiaDespacho.patenteCarro.toString().length > 8) ||
				(!!guiaDespacho.dirDest && guiaDespacho.dirDest.toString().length > 70) ||
				(!!guiaDespacho.cmnaDest && guiaDespacho.cmnaDest.toString().length > 20) ||
				(!!guiaDespacho.fechaSalida && (guiaDespacho.fechaSalida < "2003-04-01" || guiaDespacho.fechaSalida > "2050-12-31")) ||
				(!!guiaDespacho.fechaLlegada && (guiaDespacho.fechaLlegada < "2003-04-01" || guiaDespacho.fechaLlegada > "2050-12-31")) ||
				(!!guiaDespacho.fechaSalida && !!guiaDespacho.fechaLlegada && guiaDespacho.fechaLlegada < guiaDespacho.fechaSalida));

		const totalDetalles = calcularTotalDetalles({
			dte: this.newDte,
			invoiceType: this.invoiceType,
			tipoNota: this.tipoNota,
			detallesConImpuestosIncluidos: this.listElementsWithTax,
			porcentajeIva: this.porcentajeIva,
		});
		this.newDte.fecha = this.resumen.fechaEmisionActual;
		const validacion = validarDte({
			dte: this.newDte,
			invoiceType: this.invoiceType,
			tipoNota: this.tipoNota,
			referenciasActivas,
			requiereIdentificacionReceptor: this.requiereIdentificacionReceptor,
			valorUF135: this.valorUF135,
			grupoFolio: this.currentGrupoFolio,
			invalidSize: this.invalidSize,
			currentSize: this.facturador.currentSize,
			totalDetalles,
			tieneDetallesConMontosInvalidos: tieneDetallesConMontosInvalidos(this.newDte, this.invoiceType, this.tipoNota),
			esTransferenciaInterna: guiaDespacho?.tipoTraslado === 5,
			receptorTieneGiro: this.tieneGiroReceptorInformado(),
			requiereGiroReceptor: this.requiereGiroReceptor(this.newDte.codigoTipoDte),
			correoReceptor: this.receptor?.correoFact,
			proveedorValido: !(this.newDte instanceof FacturaCompra) || !!this.newDte.rutProveedor,
			clienteExportacionValido: !(this.newDte instanceof FacturaExportacion) || !!this.newDte.clienteInternacionalId,
			transporteIncompleto,
			exportacionInvalida: this.invoiceType === InvoiceType.FacturaExportacion && this.exportWithErrors(this.newDte as FacturaExportacion),
			formularioNotaInvalido: !!this.notaForm?.invalid,
		});

		if (validacion) {
			this.mostrarError(validacion.titulo, validacion.mensaje);
			return;
		}
		if (this.invoiceType === InvoiceType.FacturaExportacion) {
			(this.newDte as FacturaExportacion).indicadorServicioExportacion =
				(this.newDte as FacturaExportacion).transporte?.haveTransport === false
					? this.indicadorServicioExportacion
					: IndicadorServicioExportacion.SinEspecificar;
		}

		if (this.invoiceType !== InvoiceType.LiquidacionFactura) this.newDte.comisionesCargosDte = null;
		this.cleanEmptyDetails();

		if (!sender) {
			this.previzualiseDte(usuarioId, sucursalId, this.newDte);
			return;
		}
		this.emisionEnCurso = true;
		let continuar: boolean;
		try {
			continuar = await this.buscadorCliente?.confirmarGuardadoCliente() ?? true;
		} finally {
			this.emisionEnCurso = false;
		}
		if (!continuar) return;
		this.newDte.receptorEnt = this.receptor ? { ...this.receptor } : this.receptor;

		if (this.invoiceType === InvoiceType.Factura && this.newDte.listaReferenciasDteEmitido) {
			this.checkAndAddGuideReferences();
		}
		this.guardarPreferenciaDetallesIvaIncluido(emisorId);
		this.emitirDte(usuarioId, sucursalId);
	}

	private normalizarDetallesAntesDeEmitir(): void {
		(this.newDte.detalleDte || []).forEach((detalle, index) => {
			detalle.nroitem = index + 1;
			detalle.totalImpuestosAdicionales = !detalle.esExento ? Math.round(Number(detalle.totalImpuestosAdicionales || 0)) : 0;
			if (detalle.esExento) detalle.impuestosAdicionales = [];
			if (detalle.impuestosAdicionales && detalle.impuestosAdicionales.length > 0 && detalle.totalImpuestosAdicionales > 0) {
				detalle.impuestosAdicionales.forEach((impuesto) => (impuesto.valor = Math.round(Number(impuesto.valor || 0))));
			}
		});
		if (this.showInSettlement) {
			(this.newDte.comisionesCargosDte || []).forEach((comision, index) => (comision.nroItem = index + 1));
		}
	}

	private emitirDte(usuarioId: string, sucursalId: string): void {
		if (!this.permissions.canIssueInvoice(this.invoiceType)) { return; }
		this.emisionEnCurso = true;
		this.loading = true;
		this.scrollToTop();

		const notaDebito = this.invoiceType === InvoiceType.NotaDebito ? this.buildNotaDebito() : undefined;
		const notaCredito = this.invoiceType === InvoiceType.NotaCredito ? this.buildNotaCredito(this.tipoNota) : undefined;

		this.dteEmissionService
			.emitir({
				invoiceType: this.invoiceType,
				usuarioId,
				sucursalId,
				dte: this.newDte,
				notaDebito,
				notaCredito,
			})
			.pipe(
				take(1),
				finalize(() => {
					this.emisionEnCurso = false;
					this.loading = false;
					this.ref.detectChanges();
				})
			)
			.subscribe({
				next: (resultado) =>
					this.manejarEmisionExitosa(resultado.dteId, {
						successTitle: resultado.titulo,
						successText: resultado.mensaje,
						resetForm: resultado.reiniciarFormulario,
					}),
				error: (error) => this.mostrarError("Error en emisión", "No ha sido posible emitir el documento, intente nuevamente o contacte a su administrador " + this.utilities.setErrorMessageFromArray(error?.error)),
			});
	}

	private buildNotaDebito(): NotaDebito {
		const notaDebito = new NotaDebito();
		notaDebito.motivoString = this.notaForm?.get("motivo")?.value;
		notaDebito.tipoNota = this.tipoNota;
		if (this.newDte.listaReferenciasDteEmitido) {
			notaDebito.razonReferencias = this.newDte.listaReferenciasDteEmitido.map((referencia) => `${referencia.razonReferencia}`).join("; ");
			notaDebito.folio = parseInt(this.newDte.listaReferenciasDteEmitido.map((referencia) => referencia.folioReferencia).join("; "), 10);
		} else {
			notaDebito.razonReferencias = "";
		}
		return notaDebito;
	}

	private guardarPreferenciaDetallesIvaIncluido(emisorId: string): void {
		const control = this.opcionesRef?.optionsReferenceFormGroup?.get("detallesExentos");
		if (!control) return;
		this.emisorService.updateDetallesIvaIncluido(emisorId, control.value).pipe(take(1)).subscribe({
			error: (error) => console.error("No se pudo actualizar la preferencia de detalles", error),
		});
	}

	private mostrarError(titulo: string, mensaje: string): void {
		this.notifications.error(titulo, mensaje);
	}
	mostrarPDF(): boolean {
		// Consulta si el atributo ha sido establecido por Cypress
		return document.body.getAttribute("data-mostrar-pdf") !== "false";
	}

	private manejarEmisionExitosa(dteId: string, opciones: { successTitle: string; successText: string; resetForm: boolean }) {
		this.loading = false;
		this.documentoEmitidoExitosamente = true;
		clearTimeout(this.temporizadorPersistenciaBorrador);
		this.deshabilitarSeguimientoBorrador = true;
		this.limpiarBorradorDespuesEmision();
		this.responseResult = dteId;
		this.createNewProductsFromMarkedItems(this.newDte.detalleDte, this.newDte.emisorId);

		const finalizarEmision = () => {
			//Cuando es test, esto no se llama
			if (this.mostrarPDF()) {
				this.getPdfOfInvoice(this.responseResult, this.invoiceType);
			}
			if (opciones.resetForm) {
				this.newDte = new DteEmitido();
			}
			this.ref.detectChanges();
			this.notifications.exito(opciones.successTitle, opciones.successText);
			setTimeout(() => {
				this.deshabilitarSeguimientoBorrador = false;
			}, 500);
		};

		if (this.guardarComoFrecuenteSolicitado) {
			this.guardarComoFrecuenteSolicitado = false;
			this.guardarComoPlantillaYFinalizar(dteId, finalizarEmision);
		} else {
			finalizarEmision();
		}
	}

	private guardarComoPlantillaYFinalizar(dteId: string, finalizarEmision: () => void) {
		this.solicitarNombrePlantilla().subscribe((nombre) => {
			if (!nombre) {
				finalizarEmision();
				return;
			}
			this.facturador.guardarComoPlantilla(dteId, nombre).subscribe(
				() => {
					this.cargarPlantillas(this.currentCodigosTipoDtePlantillas);
					finalizarEmision();
				},
				() => {
					Swal.fire({
						icon: "warning",
						title: "Plantilla no guardada",
						text: "El documento fue emitido correctamente, pero no fue posible guardarlo como plantilla.",
					}).then(() => finalizarEmision());
				}
			);
		});
	}

	previzualiseDte(usuarioId: string, sucursalId: string, dteToSend: IDte) {
		if (this.emisionEnCurso) return;
		this.emisionEnCurso = true;
		this.loading = true;
		this.scrollToTop();
		let payload: IDte = dteToSend;
		if (this.invoiceType == InvoiceType.FacturaExportacion) {
			payload = prepararPayloadExportacion(dteToSend);
		}
		if (this.invoiceType === InvoiceType.NotaCredito && this.tipoNota === 2) {
			const textoCorreccion = this.notaForm?.get("itemsCorreccion")?.value?.trim();
			if (textoCorreccion) {
				payload = Object.assign({}, dteToSend, { detalleDte: [prepararDetalleCorreccionTexto(textoCorreccion)] });
			}
		}
		this.facturador
			.previewDte(usuarioId, sucursalId, payload)
			.pipe(
				take(1),
				finalize(() => {
					this.loading = false;
					this.emisionEnCurso = false;
					this.ref.detectChanges();
				})
			)
			.subscribe({
				next: (result) => {
					const pdfBlob = this.utilities.convertB64ToBlob(result.data, "application/pdf");
					const pdfUrl = URL.createObjectURL(pdfBlob);
					this.popupCenter(pdfUrl, "Muestra de Documento", 600, 800);
					setTimeout(() => URL.revokeObjectURL(pdfUrl), 60000);
				},
				error: (error) => this.mostrarError("Error en previsualización", "No ha sido posible previsualizar el documento, intente nuevamente o contacte a su administrador " + this.utilities.setErrorMessageFromArray(error?.error)),
			});
	}

	popupCenter(url, title, w, h) {
		const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
		const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;

		const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
		const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

		const systemZoom = width / window.screen.availWidth;
		const left = (width - w) / 2 / systemZoom + dualScreenLeft;
		const top = (height - h) / 2 / systemZoom + dualScreenTop;
		const newWindow = window.open(
			url,
			title,
			`
    scrollbars=yes,
    width=${w / systemZoom},
    height=${h / systemZoom},
    top=${top},
    left=${left}
    `
		);
		if (newWindow && window.focus) {
			newWindow.focus();
		} else if (!newWindow) {
			this.mostrarError("Ventana bloqueada", "Permita las ventanas emergentes para poder visualizar el documento.");
		}
	}

	private alActualizarContenidoBorrador(): void {
		if (this.restaurandoBorrador || this.deshabilitarSeguimientoBorrador || this.documentoEmitidoExitosamente) {
			return;
		}
		this.programarPersistenciaBorrador();
	}

	private programarPersistenciaBorrador(): void {
		clearTimeout(this.temporizadorPersistenciaBorrador);
		this.temporizadorPersistenciaBorrador = setTimeout(() => {
			this.persistirBorrador().catch((error) => console.error("No fue posible guardar el borrador de emisión", error));
		}, 500);
	}

	private async persistirBorrador(force: boolean = false, invoiceTypeOverride?: InvoiceType): Promise<void> {
		if (!this.currentUserId || !this.currentEmisorId) {
			return;
		}
		if (this.deshabilitarSeguimientoBorrador && !force) {
			return;
		}
		const estadoBorrador = this.construirEstadoBorrador(invoiceTypeOverride);
		try {
			if (!estadoBorrador) {
				const tipoALimpiar = invoiceTypeOverride ?? this.invoiceType;
				await this.borradorService.limpiarBorrador(this.currentUserId, this.currentEmisorId, tipoALimpiar);
				return;
			}
			await this.borradorService.guardarBorrador(estadoBorrador, this.currentUserId, this.currentEmisorId);
		} catch (error) {
			console.error("No fue posible persistir el borrador de emisión", error);
		}
	}

	private tieneContenidoBorrador(): boolean {
		const detalles = this.newDte?.detalleDte ?? [];
		const comisiones = this.newDte?.comisionesCargosDte ?? [];
		const referencias = this.newDte?.listaReferenciasDteEmitido ?? [];
		const hasDetails = detalles.some((detalle) => detalle && detalle.cantidad && detalle.cantidad > 0);
		const hasComisiones = comisiones.length > 0;
		const hasReceptor = !!this.receptor;
		const hasObservaciones = !!(this.observacionesDte && this.observacionesDte.trim().length > 0);
		let notaValue = this.notaForm ? this.notaForm.getRawValue() : null
		const hasNotaInfo = (this.invoiceType === InvoiceType.NotaCredito || this.invoiceType === InvoiceType.NotaDebito) && (!!this.motivoNota || !!(notaValue.itemsCorreccion && notaValue.itemsCorreccion.trim().length > 0));

		const ReferenciasCompletas= (referencias || []).filter(r => {
			try {
				
				return r && ((r.folioReferencia && r.folioReferencia.toString().trim().length > 0) && (r.codigoTipoDteReferencia && r.codigoTipoDteReferencia.toString().trim().length > 0));
			} catch (e) {
				return false;
			}
		});
		const comisionCompleta = (comisiones || []).filter(c => {
			try {
				return c && ((c.tipoId && c.tipoId.toString().trim().length > 0) && (c.tasa && c.tasa > 0) && (c.glosa && c.glosa.toString().trim().length > 0));
			
			} catch (e) {
				return false;
			}
		});
		const baseHasContent = hasDetails || (comisionCompleta.length > 0) || (ReferenciasCompletas.length > 0) || hasReceptor || hasObservaciones || hasNotaInfo;

		if (baseHasContent) return true;

		const totalValue = Number(this.newDte?.total ?? 0);
		const existeInputsValido  = (detalles && detalles.length > 0) || (comisionCompleta && comisionCompleta.length > 0) || (ReferenciasCompletas && ReferenciasCompletas.length > 0) || hasReceptor || hasObservaciones || hasNotaInfo;
		
		if (!isNaN(totalValue) && totalValue > 0 && existeInputsValido) return true;

		return false;
	}

	private construirEstadoBorrador(invoiceTypeOverride?: InvoiceType): EstadoBorradorDte | null {
		if (!this.tieneContenidoBorrador()) {
			return null;
		}

		const clonedNewDte = JSON.parse(JSON.stringify(this.newDte ?? {}));
		let detalles = JSON.parse(JSON.stringify(this.newDte?.detalleDte ?? []));
		const comisiones = JSON.parse(JSON.stringify(this.newDte?.comisionesCargosDte ?? []));
		const opcionesReferencia = JSON.parse(JSON.stringify(this.currentOptionsRefState ?? new OptionsReferenceDteEmitido()));
		const opcionesTransporte = JSON.parse(JSON.stringify(this.currentTransportOptionsState ?? new OptionsTransportDteEmitido()));
		const totales = JSON.parse(JSON.stringify(this.currentTotalsState ?? new TotalDteEmitido()));
		let exportacion = this.currentExportacionState ? JSON.parse(JSON.stringify(this.currentExportacionState)) : undefined;
		let clienteSeleccionado = this.facturador.selectedClient ? JSON.parse(JSON.stringify(this.facturador.selectedClient)) : null;
		const proveedorSeleccionado = this.facturador.selectedProveedor ? JSON.parse(JSON.stringify(this.facturador.selectedProveedor)) : null;
		const receptorSnapshot = this.receptor ? JSON.parse(JSON.stringify(this.receptor)) : null;
		 if (this.invoiceType === InvoiceType.FacturaExportacion && Array.isArray(detalles)) {
            detalles = detalles.map((detalle: any) => {
                if (detalle && detalle.originalValuePrice !== undefined && detalle.originalValuePrice !== null) {
                    detalle.precioUnitario = detalle.originalValuePrice;
                }
                return detalle;
            });
        }

		delete clonedNewDte.detalleDte;
		delete clonedNewDte.comisionesCargosDte;

		try {
			if (receptorSnapshot) {
				if (!clienteSeleccionado && (receptorSnapshot.clienteInternacionalId || receptorSnapshot.nombrePais || receptorSnapshot.codigoPais || receptorSnapshot.paisId)) {
					clienteSeleccionado = { ...receptorSnapshot };
				} else if (clienteSeleccionado) {
					if ((!clienteSeleccionado.nombrePais || clienteSeleccionado.nombrePais === "") && (receptorSnapshot.nombrePais)) {
						clienteSeleccionado.nombrePais = receptorSnapshot.nombrePais;
					}
					if ((!clienteSeleccionado.codigoPais || clienteSeleccionado.codigoPais === undefined) && (receptorSnapshot.codigoPais || receptorSnapshot.paisId)) {
						clienteSeleccionado.codigoPais = receptorSnapshot.codigoPais ?? receptorSnapshot.paisId;
					}
					if ((!clienteSeleccionado.paisId || clienteSeleccionado.paisId === undefined) && receptorSnapshot.paisId) {
						clienteSeleccionado.paisId = receptorSnapshot.paisId;
					}
					if ((!clienteSeleccionado.clienteInternacionalId || clienteSeleccionado.clienteInternacionalId === 0) && receptorSnapshot.clienteInternacionalId) {
						clienteSeleccionado.clienteInternacionalId = receptorSnapshot.clienteInternacionalId;
					}
					if ((!clienteSeleccionado.clienteInternacionalId || clienteSeleccionado.clienteInternacionalId === 0) && 
						this.invoiceType === InvoiceType.FacturaExportacion && (clonedNewDte as any)?.clienteInternacionalId) {
						clienteSeleccionado.clienteInternacionalId = (clonedNewDte as any).clienteInternacionalId;
					}
				}
				if (!exportacion) {
					exportacion = {} as any;
				}
				if (receptorSnapshot && (!exportacion.paisReceptor || exportacion.paisReceptor === "")) {
					exportacion.paisReceptor = receptorSnapshot.nombrePais ?? exportacion.paisReceptor;
				}
				if (receptorSnapshot && (!exportacion.codigoPaisReceptor || exportacion.codigoPaisReceptor === undefined)) {
					exportacion.codigoPaisReceptor = receptorSnapshot.codigoPais ?? receptorSnapshot.paisId ?? exportacion.codigoPaisReceptor;
				}
			}
		} catch (err) {
		}

		const estado: EstadoBorradorDte = {
			invoiceType: invoiceTypeOverride ?? this.invoiceType,
			newDte: clonedNewDte,
			detalles,
			comisiones,
			opcionesReferencia,
			opcionesTransporte,
			totales,
			clienteSeleccionado,
			proveedorSeleccionado,
			receptor: receptorSnapshot,
			observacionesDte: this.observacionesDte,
			showInGuide: this.showInGuide,
			showTransporte: this.showTransporte,
			dontShowInSettlement: this.dontShowInSettlement,
			showInSettlement: this.showInSettlement,
			showInExportInvoice: this.showInExportInvoice,
			tipoNota: this.tipoNota,
			motivoNota: this.motivoNota,
			itemsCorreccion: this.notaForm ? this.notaForm.get("itemsCorreccion").value : this.itemsCorreccion,
			notaFormValue: this.notaForm ? this.notaForm.getRawValue() : null,
			exportacionTransporte: exportacion,
			timestamp: new Date().toISOString(),
			version: 1,
		};
		return estado;

	}
	private async mostrarAvisoRestaurarBorrador(): Promise<void> {
		this.verificacionBorradorCompletada = true;
		try {
			const borrador = await this.borradorService.obtenerBorrador(this.currentUserId, this.currentEmisorId, this.invoiceType);
			if (!borrador) {
				return;
			}
			try {
				const borradorTipo = Number((borrador as any).invoiceType);
				if (!isNaN(borradorTipo) && borradorTipo !== Number(this.invoiceType)) {
					return;
				}
			} catch (err) {
			}
			const result = await Swal.fire({
				title: "Borrador pendiente",
				text: "Detectamos un proceso de emisión que no se completó. ¿Deseas continuarlo?",
				icon: "info",
				confirmButtonText: "Continuar con el proceso",
				cancelButtonText: "Descartar borrador",
				showCancelButton: true,
				heightAuto: false,
				width: "28rem",
				customClass: {
					popup: "swal2-popup--compact",
				},
			});

			if (result.isConfirmed) {
				await this.restaurarEstadoBorrador(borrador);
			} else {
				await this.borradorService.limpiarBorrador(this.currentUserId, this.currentEmisorId, this.invoiceType);
			}
		} catch (error) {
			console.error("No fue posible recuperar el borrador de emisión", error);
		}
	}

	private async restaurarEstadoBorrador(borrador: EstadoBorradorDte): Promise<void> {
		this.restaurandoBorrador = true;
		this.deshabilitarSeguimientoBorrador = true;
		try {
			Object.assign(this.newDte, borrador.newDte ?? {});
			if (borrador.newDte?.fecha) {
				this.newDte.fecha = new Date(borrador.newDte.fecha);
			}
			if ((borrador.newDte as any)?.fechaReferencia) {
				this.newDte.fechaReferencia = new Date((borrador.newDte as any).fechaReferencia);
			}
			if (borrador.newDte?.listaReferenciasDteEmitido) {
				this.newDte.listaReferenciasDteEmitido = borrador.newDte.listaReferenciasDteEmitido.map((ref) => {
					const referencia = Object.assign(new ReferenciaDteEmitido(), ref);
					if (ref?.fechaDteReferenciado) {
						referencia.fechaDteReferenciado = new Date(ref.fechaDteReferenciado);
					}
					return referencia;
				});
			}
			if (borrador.newDte?.guiaDespacho) {
				this.newDte.guiaDespacho = Object.assign(new GuiaDespacho(), borrador.newDte.guiaDespacho);
			}

			const detalles = (borrador.detalles || []).map((detalle) => Object.assign(new DetalleDte(), detalle));
			const comisiones = (borrador.comisiones || []).map((detalle) => Object.assign(new ComisionRecargo(), detalle));
			this.facturador.setList(detalles);
			this.facturador.setComisionList(comisiones);

			this.currentOptionsRefState = Object.assign(new OptionsReferenceDteEmitido(), borrador.opcionesReferencia ? borrador.opcionesReferencia : new OptionsReferenceDteEmitido());
			this.facturador.updateOptionsReferences(this.currentOptionsRefState);

			this.currentTransportOptionsState = Object.assign(new OptionsTransportDteEmitido(), borrador.opcionesTransporte ? borrador.opcionesTransporte : new OptionsTransportDteEmitido());
			this.facturador.updateOptionsTransport(this.currentTransportOptionsState);

			if (borrador.totales) {
				this.currentTotalsState = Object.assign(new TotalDteEmitido(), borrador.totales);
				if (borrador.totales.fechaEmision) {
					this.currentTotalsState.fechaEmision = new Date(borrador.totales.fechaEmision);
				}
				this.facturador.updateTotales(this.currentTotalsState);
			}
			this.resumen?.cargarFechaEmision(this.newDte.fecha);

			if (borrador.exportacionTransporte) {
				this.currentExportacionState = Object.assign(new ExportacionTransporteDte(), borrador.exportacionTransporte);
				this.facturador.updateExportacionTransporte(this.currentExportacionState);
			}

			if (borrador.clienteSeleccionado) {
				this.facturador.selectedClient = borrador.clienteSeleccionado as Receptor;
				const rutCliente = (borrador.clienteSeleccionado as Receptor).rutString ?? "";
				this.facturador.updateClient(rutCliente, borrador.clienteSeleccionado as Receptor);
				
				if (this.invoiceType === InvoiceType.FacturaExportacion && (borrador.clienteSeleccionado as any)?.clienteInternacionalId) {
					(this.newDte as FacturaExportacion).clienteInternacionalId = (borrador.clienteSeleccionado as any).clienteInternacionalId;
				}
				
				this.addClientToInvoiceRequest(borrador.clienteSeleccionado as Receptor);
			}

			if (borrador.proveedorSeleccionado) {
				this.facturador.selectedProveedor = borrador.proveedorSeleccionado as Proveedor;
				const rutProveedor = (borrador.proveedorSeleccionado as Proveedor).rutProveedor ?? "";
				this.facturador.updateProveedor(rutProveedor, borrador.proveedorSeleccionado as Proveedor);
				this.addProveedorToInvoiceRequest(borrador.proveedorSeleccionado as Proveedor);
			}

			this.receptor = borrador.receptor ?? borrador.proveedorSeleccionado ?? borrador.clienteSeleccionado ?? this.receptor;
			
			if (this.invoiceType === InvoiceType.FacturaExportacion && this.receptor && (this.receptor as any)?.clienteInternacionalId) {
				(this.newDte as FacturaExportacion).clienteInternacionalId = (this.receptor as any).clienteInternacionalId;
			}
			if (borrador.observacionesDte !== undefined) {
				this.observacionesDte = borrador.observacionesDte ?? "";
			}
			this.tipoPago = borrador.newDte?.tipoPago ?? "";
			this.showInGuide = borrador.showInGuide ?? this.showInGuide;
			this.showTransporte = borrador.showTransporte ?? this.showTransporte;
			this.dontShowInSettlement = borrador.dontShowInSettlement ?? this.dontShowInSettlement;
			this.showInSettlement = borrador.showInSettlement ?? this.showInSettlement;
			this.showInExportInvoice = borrador.showInExportInvoice ?? this.showInExportInvoice;
			if (borrador.tipoNota !== undefined) {
				this.tipoNota = borrador.tipoNota;
			}
			if (borrador.motivoNota !== undefined) {
				this.motivoNota = borrador.motivoNota ?? "";
			}
			if (borrador.itemsCorreccion !== undefined) {
				this.itemsCorreccion = borrador.itemsCorreccion ?? "";
			}
			if (borrador.notaFormValue && this.notaForm) {
				this.notaForm.patchValue(borrador.notaFormValue);
			}
			if (this.motivoNota) {
				this.notaForm.get("motivo").setValue(this.motivoNota);
			}
			this.newDte.receptorEnt = this.receptor;

			if (this.invoiceType === InvoiceType.FacturaExportacion && this.receptor && (this.receptor as any)?.clienteInternacionalId && 
				!(this.newDte as FacturaExportacion).clienteInternacionalId) {
				(this.newDte as FacturaExportacion).clienteInternacionalId = (this.receptor as any).clienteInternacionalId;
			}
			
			this.ref.detectChanges();
		} finally {
			this.restaurandoBorrador = false;
			setTimeout(() => {
				this.deshabilitarSeguimientoBorrador = false;
			}, 0);
		}
	}

	private async limpiarBorradorDespuesEmision(): Promise<void> {
		if (!this.currentUserId || !this.currentEmisorId) {
			return;
		}
		try {
			await this.borradorService.limpiarBorrador(this.currentUserId, this.currentEmisorId, this.invoiceType);
		} catch (error) {
			console.error("No fue posible limpiar el borrador de emisión", error);
		}
	}

	private resetearEstadoEmision(): void {
		this.deshabilitarSeguimientoBorrador = false;
		this.documentoEmitidoExitosamente = false;
	}

	ngAfterViewInit(): void {
		this.iniciarTourSiEsPrimeraVez();
	}

	private iniciarTourSiEsPrimeraVez(): void {
		this.usuarioService.getTourFacturadorVisto().subscribe({
			next: (result) => {
				if (result.data) return;
				this.esperarElementosYIniciarTour();
			},
			error: () => {},
		});
	}

	private esperarElementosYIniciarTour(intentos: number = 0): void {
		if (intentos > 20) return;
		if (!document.querySelector(".facturador-header__titulo")) {
			setTimeout(() => this.esperarElementosYIniciarTour(intentos + 1), 300);
			return;
		}
		const pasosDisponibles = ConfiguracionesTour.FACTURADOR_INDIVIDUAL.steps.filter((paso) => !!document.querySelector(paso.element));
		if (pasosDisponibles.length === 0) return;
		this.tourService.iniciarTour(
			{ ...ConfiguracionesTour.FACTURADOR_INDIVIDUAL, steps: pasosDisponibles },
			{
				enCambioPaso: (_indice, paso) => this.prepararPasoTour(paso),
				alFinalizar: () => this.marcarTourFacturadorVisto(),
			}
		);
	}

	private prepararPasoTour(paso?: PasoTour): void {
		if (!paso?.panelTab || !this.panelComplementario) return;
		this.panelComplementario.openTab(paso.panelTab as PanelComplementarioTab);
		this.ref.detectChanges();
	}

	private marcarTourFacturadorVisto(): void {
		this.usuarioService.marcarTourFacturadorVisto().subscribe({ error: () => {} });
	}

	cargarDivisas(reintentar = false): void {
		this.errorDivisas = false;
		this.dashboard.getDailyDivisas(reintentar).pipe(takeUntil(this.destroySubscriptions$)).subscribe({
			next: (respuesta) => {
				this.listDivisas = Array.isArray(respuesta?.data) ? respuesta.data.filter((divisa) => divisa != null) : [];
				this.errorDivisas = this.listDivisas.length === 0;
				this.facturador.updateDivisas(this.listDivisas);
			},
			error: () => {
				this.errorDivisas = true;
			},
		});
	}

	ngOnDestroy() {
		const tipoActual = this.invoiceType;
		this.deshabilitarSeguimientoBorrador = true;
		clearTimeout(this.temporizadorPersistenciaBorrador);
		const tareaBorrador = !this.documentoEmitidoExitosamente ? this.persistirBorrador(true, tipoActual) : this.limpiarBorradorDespuesEmision();

		this.destroySubscriptions$.next();
		this.destroySubscriptions$.complete();
		this.facturador.publishReferencesFromGuides([]);
		this.facturador.resetElements();

		// El navegador no espera promesas durante la destrucción del componente.
		// La instantánea ya fue construida antes del primer await; el estado visual
		// se limpia inmediatamente para que no afecte a una nueva navegación.
		tareaBorrador.catch((error) => console.error("No fue posible finalizar el borrador al cerrar el facturador", error));
	}

	cleanEmptyDetails() {
		this.newDte.detalleDte.forEach((detail) => {
			if (!detail.cantidad || detail.cantidad <= 0) {
				this.newDte.detalleDte = this.newDte.detalleDte.filter((d) => d !== detail);
			}
		});
		if (this.invoiceType == InvoiceType.LiquidacionFactura) {
			if (this.newDte.comisionesCargosDte && Array.isArray(this.newDte.comisionesCargosDte)) {
				this.newDte.comisionesCargosDte = this.newDte.comisionesCargosDte.filter((detail) => detail && Number(detail.cantidad) > 0 && detail.tipoId && detail.tipoId.toString().trim().length > 0);
			}
		}
	}

	reloadCurrentRoute() {
		this.router.navigateByUrl(obtenerConfiguracionDte(this.invoiceType).rutaMantenedor);
	}

	scrollToTop() {
		window.scroll(0, 0);
	}

	createNewProductsFromMarkedItems(itemList: DetalleDte[], currentEmisorId: string) {
		const list = [...(itemList || [])];
		const emisorId = currentEmisorId;
		const productsToCreate = list.filter((item) => item.createCurrentProduct === true);
		if (!productsToCreate || productsToCreate.length <= 0) {
			this.facturador.resetElements();
			this.reloadCurrentRoute();
		} else {
			const requestList = productsToCreate.map((item, index) =>
				this.productService.sendProductRequestFromDetalleDte(item, emisorId).pipe(
					map((response) => ({ success: true as const, response, index })),
					catchError((error) => of({ success: false as const, error, index }))
				)
			);
			this.loading = true;
			forkJoin(requestList)
				.pipe(
					finalize(() => {
						this.loading = false;
						this.newDte = new DteEmitido();
						this.facturador.resetElements();
						this.ref.detectChanges();
					})
				)
				.subscribe((results) => {
					const exitosos = results.filter((result) => result.success);
					const fallidos = results.filter((result) => !result.success);
					if (exitosos.length > 0) {
						const productosIngresados = results
							.map((result) => (result.success ? (result.response as Response<Producto>).data + ": " + productsToCreate[result.index].nombre : ""))
							.filter((value) => !!value);
						Swal.fire({
							icon: fallidos.length > 0 ? "warning" : "success",
							title: fallidos.length > 0 ? "Productos ingresados parcialmente" : "Productos Agregados",
							text: "Productos ingresados:\n" + productosIngresados.join("\n") + (fallidos.length > 0 ? `\nNo fue posible ingresar ${fallidos.length} producto(s).` : ""),
						});
					} else {
						Swal.fire({
							icon: "error",
							title: "Ingreso de Productos",
							text: "No fue posible ingresar los productos",
						});
					}
					this.reloadCurrentRoute();
				});
		}
	}

	getDocTypeParamFromStateRoute() {
		this.loading = true;
		const result = window.history.state || {};
		const invoiceType = Number.isInteger(result.invoiceType) ? result.invoiceType as InvoiceType : InvoiceType.Factura;
		this.invoiceType = invoiceType;
		if (!this.permissions.canIssueInvoice(invoiceType)) {
			this.loading = false;
			this.router.navigateByUrl("/inicio");
			return;
		}

		this.modificationsByInvoiceType(invoiceType);
		this.facturador.setCurrentInvoiceType(invoiceType);

		const configuracion = obtenerConfiguracionDte(this.invoiceType);
		this.showTransporte = configuracion.mostrarTransporte;
		const tipoDTE = this.tipoDteSource.find((x) => x.codigosii == configuracion.primaryCodigoSii);
		this.getFoliosDisponibles();
		if (tipoDTE) this.getFormatSizes(this.tokenService.getCompany(), tipoDTE.tipoDteId);
		this.cargarPlantillas(configuracion.codigosSii);

		const dteExistente = result.dteExistente;
		if (dteExistente) this.cargarDatosDesdeDte(dteExistente.dteId);
		else this.mostrarAvisoRestaurarBorrador();
		this.loading = false;
	}

	cargarDatosDesdeDte(dteId: string, esPlantilla: boolean = false) {
		forkJoin([this.dteService.getInfoDetalleDte(dteId), this.dteService.getReferenciasDte(dteId)])
			.pipe(take(1))
			.subscribe(
				([dte, referenciasResponse]) => {

					const receptorXml = dte.dteEmitido.receptorEnt;
					const receptor = { ...(receptorXml?.rutString ? receptorXml : dte.receptor) };
					receptor.clienteId = dte.dteEmitido.clienteId || receptor.clienteId;
					const rutReceptor = receptor.rutString;
					receptor.receptorId = rutReceptor && rutReceptor === dte.receptor?.rutString ? dte.receptor.receptorId ?? undefined : undefined;
					this.receptor = receptor;
					const impuestosSource = JSON.parse(this.localStorage.getImpuestos() || "[]") as Impuesto[];
					dte.dteEmitido.detalleDte = mapDetallesForCopiedDte(dte.dteEmitido.detalleDte, impuestosSource);
					if (esPlantilla) {
						// las plantillas se emiten con la fecha actual, no con la fecha del documento original
						dte.dteEmitido.fecha = new Date();
					}
					this.dteExistente = dte.dteEmitido;
					this.dteExistente.receptorId = receptor.receptorId;
					this.observacionesDte = dte.dteEmitido.observaciones ?? "";
					this.tipoPago = dte.dteEmitido.tipoPago ?? "";
					this.newDte.tipoPago = this.tipoPago;
					const referenciasCopiadas = mapReferenciasDetalleToEmitidas(referenciasResponse.data, dte.dteEmitido.listaReferenciasDteEmitido);
					this.dteExistente.listaReferenciasDteEmitido = referenciasCopiadas;
					this.newDte.listaReferenciasDteEmitido = referenciasCopiadas;
					this.facturador.updateOptionsReferences(buildOptionsReferenceForCopiedDte(dte.dteEmitido, referenciasCopiadas));
					if (this.invoiceType === InvoiceType.GuiaDespacho) {
						this.facturador.updateOptionsTransport(buildTransportOptionsForCopiedDte(dte.dteEmitido));
					}

					this.dteInvoice.rutReceptor = receptor.rutString;
					this.newDte.razonSocial = receptor.razonSocial;
					this.newDte.receptorEnt = receptor;
					this.newDte.receptorId = receptor.receptorId;
					this.newDte.dteId = dte.dteEmitido.dteId;

					this.newDte.rutReceptor = rutReceptor ? rutReceptor.split("-")[0] : dte.dteEmitido.rutReceptor;
					this.newDte.rutReceptorDv = receptor.rutString;

					this.listElementsWithTax = false;
					this.dteExistente.receptorEnt = receptor;
					if (this.invoiceType == InvoiceType.LiquidacionFactura) {
						if (dte.dteEmitido.comisionesCargosDte && dte.dteEmitido.comisionesCargosDte.length > 0) {
							this.facturador.setComisionList(dte.dteEmitido.comisionesCargosDte);
						}
					}
					this.ref.detectChanges();
				},
				(error) => {
					this.loading = false;
					this.ref.detectChanges();
					//this.setSwalAndFire(this.currentSwal, "error", "Error al obtener detalles", "No fue posible obtener los detalles del documento indicado, intente mas tarde o comuniquese con su administrador" + this.utilities.setErrorMessageFromArray(error.error));
				}
			)
			.add(() => {
				this.loading = false;
				this.ref.detectChanges();
				// this.detailModal = this.modalService.open(modalRef, {
				// 	windowClass: "",
				// 	size: "lg",
				// 	centered: true,
				// });
			});
	}

	getCodigosTipoDtePlantillas(type: InvoiceType): number[] {
		return [...obtenerConfiguracionDte(type).codigosSii];
	}

	nombreTipoDtePlantilla(codigoTipoDte: number): string {
		return obtenerNombreDtePorCodigo(codigoTipoDte);
	}

	get tituloFormulario(): string {
		if (this.invoiceType === InvoiceType.LiquidacionFactura) return "Emisión de Liquidación";
		const codigoFallback = this.getCodigosTipoDtePlantillas(this.invoiceType)[0];
		const nombre = this.currentGrupoFolio?.nombre || (codigoFallback ? this.nombreTipoDtePlantilla(codigoFallback) : "Documento Electrónico");
		return "Emisión de " + nombre;
	}

	get mostrarBotonFacturarGuias(): boolean {
		return this.invoiceType === InvoiceType.Factura;
	}

	cargarPlantillas(codigosTipoDte?: number[]) {
		this.currentCodigosTipoDtePlantillas = codigosTipoDte?.length ? codigosTipoDte : null;
		this.facturador.getPlantillas(this.tokenService.getCompany(), this.currentCodigosTipoDtePlantillas).subscribe(
			(result) => {
				this.plantillas = result.data || [];
				this.ref.detectChanges();
			},
			() => {
				this.plantillas = [];
				this.ref.detectChanges();
			}
		);
	}

	onPlantillaSeleccionada(plantilla: PlantillaDte) {
		this.plantillaSeleccionada = plantilla;
		if (!plantilla) return;
		this.loading = true;
		if (this.emisionFrecuenteModal) {
			this.emisionFrecuenteModal.close();
		}
		this.cargarDatosDesdeDte(plantilla.dteId, true);
	}

	abrirModalEmisionFrecuente() {
		this.emisionFrecuenteModal = this.modalService.open(this.emisionFrecuenteModalRef, {
			windowClass: "",
			size: "lg",
		});
	}

	abrirModalMoneda() {
		this.monedaModal = this.modalService.open(this.monedaModalRef, {
			centered: true,
			size: "md",
		});
	}

	eliminarPlantilla(plantilla: PlantillaDte) {
		Swal.fire({
			icon: "warning",
			title: "Eliminar plantilla",
			text: `¿Está seguro de eliminar la plantilla "${plantilla.nombrePlantilla}"? Esta acción no se puede deshacer.`,
			showCancelButton: true,
			confirmButtonText: "Eliminar",
			cancelButtonText: "Cancelar",
			confirmButtonColor: "#F64E60",
		}).then((result) => {
			if (!result.isConfirmed) return;
			this.facturador.eliminarPlantilla(plantilla.dteId).subscribe(
				() => {
					this.cargarPlantillas(this.currentCodigosTipoDtePlantillas);
				},
				() => {
					Swal.fire({
						icon: "error",
						title: "Error al eliminar",
						text: "No fue posible eliminar la plantilla. Intente nuevamente.",
					});
				}
			);
		});
	}

	private solicitarNombrePlantilla(): Observable<string | null> {
		return from(
			Swal.fire({
				title: "Documento generado correctamente.",
				text: "Para guardar esta emisión como frecuente, ingrese un nombre para identificarla en futuras emisiones.",
				input: "text",
				inputPlaceholder: "Nombre de emisión frecuente",
				showCancelButton: true,
				confirmButtonText: "Guardar",
				cancelButtonText: "Cancelar",
				inputValidator: (value) => (!value || !value.trim() ? "Debe ingresar un nombre para guardar la emisión frecuente." : null),
			})
		).pipe(map((result) => (result.isConfirmed ? (result.value as string).trim() : null)));
	}

	modificationsByInvoiceType(type: InvoiceType) {
		this.showInGuide = type === InvoiceType.GuiaDespacho;
		this.showInExportInvoice = type === InvoiceType.FacturaExportacion;
		this.dontShowInSettlement = type === InvoiceType.LiquidacionFactura;
		this.showInSettlement = type === InvoiceType.LiquidacionFactura;
		if (type === InvoiceType.FacturaCompra) this.newDte = new FacturaCompra();
		else if (type === InvoiceType.FacturaExportacion) this.newDte = new FacturaExportacion();
		else this.newDte = new SolicitudDte();
	}

	solicitarCodigosAduana() {
		this.loading = true;
		this.facturador.getCodigosAduana().subscribe(
			(result) => {
				let codigos = result.data;
				codigos.unidadMedidas.forEach((unidad) => {
					unidad.nombreSigla = unidad.codigoArancelario + " - " + unidad.nombreUnidadMedida;
				});
				this.localStorage.saveCodigosAduana(codigos);

				this.loading = false;
				this.ref.detectChanges();
			},
			(error) => {
				this.loading = false;
				this.ref.detectChanges();
				Swal.fire({
					icon: "error",
					title: "Error en Codigos",
					text: "No fue posible obtener los códigos de aduanas para emitir una factura de exportación,recargue la pagina e intene nuevamente " + this.utilities.setErrorMessageFromArray(error.error),
				});
			}
		);
	}

	exportWithErrors(newDte: FacturaExportacion): boolean {
		const transport = newDte.transporte;
		const esServicioLocal = transport && transport.haveTransport === false;

		if (esServicioLocal) {
			return !esIndicadorServicioLocalExportacion(this.indicadorServicioExportacion);
		}

		if (!transport) {
			return true;
		}

		const camposCompletos =
			transport.flete             != null &&
			transport.medidaPesoBruto   != null &&
			transport.medidaPesoNeto    != null &&
			transport.medidaTara        != null &&
			transport.paisReceptor      != null &&
			transport.pesoBruto         != null &&
			transport.pesoNeto          != null &&
			transport.seguro            != null &&
			transport.tara              != null &&
			transport.viaTransporte     != null;

		return !camposCompletos;
	}


	returnToMaintainer() {
		let returnTo = "/";
		returnTo = this.setReturnUrl();
		this.router.navigateByUrl(returnTo);
	}

	setReturnUrl() {
		return obtenerConfiguracionDte(this.invoiceType).rutaMantenedor;
	}

	onSelect({ selected }) {
		this.selectedGuides.splice(0, this.selectedGuides.length);
		this.selectedGuides.push(...selected);
	}

	selectAll(event) {
		if (!this.selectedAllItemsInPage[0]) {
			if (this.selectedGuides.length > 0) {
				this.listaGuiasFacturables.map((dte) => {
					this.selectedGuides = this.selectedGuides.filter((selectedDte) => selectedDte.dteId !== dte.dteId);
				});
			}
			this.selectedGuides.push(...this.listaGuiasFacturables);
			this.selectedGuides = [...this.selectedGuides];
			this.selectedAllItemsInPage[0] = true;
		} else {
			this.listaGuiasFacturables.map((dte) => {
				this.selectedGuides = this.selectedGuides.filter((selectedDte) => selectedDte.dteId !== dte.dteId);
			});
			this.selectedAllItemsInPage[0] = false;
		}
	}
	consultaGuiasFacturablesCliente() {
		let usuarioId = (this.tokenService.getUser() as SessionUser).id;
		let emisorId = this.tokenService.getCompany();
		this.loading = true;
		if (this.facturador.selectedClient == undefined) {
			this.loading = false;
			Swal.fire({
				icon: "error",
				title: "Error al consultar guias de despacho",
				text: "No ha seleccionado un cliente para consultar sus guias de despacho disponibles para facturar",
			});
			return;
		}
		this.facturador.checkForBillableGuides(emisorId, this.facturador.selectedClient.clienteId || this.facturador.selectedClient.receptorId, usuarioId).subscribe(
			(result) => {
				this.loading = false;
				this.ref.detectChanges();
				if (result.data.length > 0) {
					this.listaGuiasFacturables = result.data;
					this.showGuideListInModal(this.listaGuiasModalRef);
				} else {
					Swal.fire({
						icon: "info",
						title: "Guias de Despacho Facturables",
						text: "No hay guias de despacho facturables para el cliente seleccionado",
					});
				}
			},
			(error) => {
				this.loading = false;
				this.ref.detectChanges();
				Swal.fire({
					icon: "error",
					title: "Error en Guias de Despacho",
					text: "Error al obtener guias de despacho facturables para el cliente seleccionado",
				});
			}
		);
	}

	showGuideListInModal(modalRef) {
		this.selectedGuides = [];
		this.incluirDocumentosReferenciadosGuias = false;
		this.guiasModal = this.modalService.open(modalRef, {
			windowClass: "",
			size: "lg",
		});
	}
	processGuidesIntoInvoice() {
		this.guiasModal.close();
		//get references
		this.processGuideToReferences(this.selectedGuides);

		//get details
		this.processGuideToDetails(this.selectedGuides);
	}

	processGuideToReferences(list: DteEmitido[]) {
		const referenciasGuias = this.incluirDocumentosReferenciadosGuias ? mapearReferenciasDocumentosDeGuias(list) : [];
		const referenciasPrincipales = this.currentGlobaleCheckGuidRefs && list.length > 0 ? [agruparReferenciasDeGuias(list)] : mapearGuiasAReferencias(list);
		this.facturador.publishReferencesFromGuides([...referenciasPrincipales, ...referenciasGuias]);
	}

	processGuideToDetails(list: DteEmitido[]) {
		this.facturador.publishDetailsFromGuides(mapearGuiasADetalles(list));
	}

	guideToIndividualReferencesList(list: DteEmitido[]) {
		this.facturador.publishReferencesFromGuides(list.map(mapearGuiaAReferencia));
	}

	guideToRef(item: DteEmitido): ReferenciaDteEmitido {
		return mapearGuiaAReferencia(item);
	}

	guideToGroupedReferenceItem(list: DteEmitido[]) {
		const referenciasPrincipales = list && list.length ? [agruparReferenciasDeGuias(list)] : [];
		const referenciasGuias = this.incluirDocumentosReferenciadosGuias ? mapearReferenciasDocumentosDeGuias(list) : [];
		this.facturador.publishReferencesFromGuides([...referenciasPrincipales, ...referenciasGuias]);
	}

	guidesToIndividualDetailList(list: DteEmitido[]) {
		this.facturador.publishDetailsFromGuides(mapearGuiasADetalles(list));
	}

	guidesToGroupedDetailList(list: DteEmitido[]) {
		this.facturador.publishDetailsFromGuides(mapearGuiasADetalles(list));
	}

	getPdfOfInvoice(id: string, type: InvoiceType) {
		let req = this.getPdfRequest(id, type);
		req.pipe(take(1)).subscribe(
			(res) => {
				let pdfBlob = this.utilities.convertB64ToBlob(res.data, "application/pdf");
				let pdfUrl = URL.createObjectURL(pdfBlob);
				this.popupCenter(pdfUrl, "Muestra de Documento", 600, 800);
				setTimeout(() => URL.revokeObjectURL(pdfUrl), 60000);
			},
			(error) => {
				const detalleError = error?.error ? this.utilities.setErrorMessageFromArray(error.error) : "";
				this.mostrarError("Error al obtener el PDF", "El documento fue emitido, pero no fue posible abrir su PDF. Puede obtenerlo desde el mantenedor. " + detalleError);
			}
		);
	}

	getPdfRequest(id: string, type: InvoiceType): Observable<Response<any>> {
		let pdfRequest;
		switch (type) {
			case InvoiceType.LiquidacionFactura: {
				pdfRequest = this.dteService.getPdfLiquidacion(id);
				return pdfRequest;
			}
			case InvoiceType.FacturaExportacion: {
				pdfRequest = this.dteExportaService.getPdf(id);
				return pdfRequest;
			}
			default: {
				pdfRequest = this.dteService.getPdf(id);
				return pdfRequest;
			}
		}
	}

	checkAndAddGuideReferences() {
		//if invoice is based in guide as references,add those references in the invoice request
		if (this.newDte.listaReferenciasDteEmitido.every((ref) => ref.codigoTipoDteReferencia == "52") && this.selectedGuides.length > 0) {
			this.newDte.guiasFacturadas = this.selectedGuides.map((guide) => guide.dteId);
		}
	}

	getFoliosDisponibles() {
		const codeDTE = obtenerConfiguracionDte(this.invoiceType).primaryCodigoSii;
		if (codeDTE != undefined) {
			this.foliosService.getDataByType(this.currentEmisorId, this.currentSucursalId, codeDTE).pipe(take(1)).subscribe(
				(res) => {
					this.listFolioResumen = resumirFolios(res.data, (tipoDteId) => this.getDteTypeName(tipoDteId));
					this.informarTipoFolio(this.invoiceType);
					this.ref.detectChanges();
				},
				(err) => {}
			);
		}
	}

	sendTipoFolio(codigo: number) {
		let grupoFolio = this.listFolioResumen.find((resumenTipo) => resumenTipo.codigoSii == codigo);
		if (grupoFolio) {
			this.facturador.passTipoCantidadFolio([grupoFolio.nombre, grupoFolio.suma]);
		} else {
			this.facturador.passTipoCantidadFolio(["", 0]);
		}
		this.currentGrupoFolio = grupoFolio;
	}

	getDteTypeName(dteTypeId): string {
		return this.tipoDteSource.find((type) => type.tipoDteId == dteTypeId)?.nombre || "Documento Electrónico";
	}

	informarTipoFolio(type: InvoiceType) {
		if (this.listFolioResumen && this.listFolioResumen.length > 0) {
			this.sendTipoFolio(obtenerConfiguracionDte(type).primaryCodigoSii);
		}
	}
}
